// removed by extract-text-webpack-plugin
module.exports = {"councilWrapper":"map-container-module__councilWrapper___2V7Dt","mapWrapper":"map-container-module__mapWrapper___3cLWg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/map-container/map-container.module.scss
// module id = 659
// module chunks = 0 1